import { render, staticRenderFns } from "./Actualizaciones.vue?vue&type=template&id=b0a99ca0&"
import script from "./Actualizaciones.vue?vue&type=script&lang=js&"
export * from "./Actualizaciones.vue?vue&type=script&lang=js&"
import style0 from "./Actualizaciones.vue?vue&type=style&index=0&id=b0a99ca0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports